import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";

export function ProtectedRoute({ children }) {
    const { token } = useAuth();

    //TODO Aqui debo detectar si el token esta valido o redireccionar (token solo revisa si existe)

    return token ? children : <Navigate to="/login" replace />;
}
